import { useState, useEffect } from 'react'
import { getSubdomain, isValidSubdomain } from '@/utils/subdomain'

export const useSubdomain = () => {
  const [subdomain, setSubdomain] = useState<string>('')
  const [isValid, setIsValid] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    const currentSubdomain = getSubdomain()
    setSubdomain(currentSubdomain)
    setIsValid(isValidSubdomain(currentSubdomain))
    setIsLoading(false)
  }, [])

  return { subdomain, isValid, isLoading }
}
